<template>
  <div>
    <div v-if="error === null">
      <div v-if="isToCallStage" class="center">
        <a-button
          v-if="showButton == false"
          type="primary"
          @click="createIncident"
        >
          Créer un incident
        </a-button>
        <Modal v-else @onUserInformation="modifyUserInformation($event)" />
      </div>
      <Technician v-else-if="isInterventionConfirmedStage" />
      <TicketPending v-else />
    </div>
    <div v-else class="center">
      <p>{{ error }}</p>
    </div>
  </div>
</template>

<script>
import Vue from "vue";
import { Button } from "ant-design-vue";
import { mapGetters } from "vuex";
import TicketPending from "./TicketPending.vue";
import Technician from "./Technician.vue";
import Modal from "./Modal.vue";

Vue.use(Button);

export default {
  name: "ActionBody",
  components: { TicketPending, Technician, Modal },
  computed: {
    ...mapGetters([
      "isToCallStage",
      "isCalledStage",
      "isInterventionConfirmedStage",
      "error",
      "userInformation",
    ]),
  },
  created: async function() {
    const roomId = this.$route.query.roomId;
    if (!roomId) {
      this.$store.dispatch("triggerError");
      return;
    }

    this.$store.dispatch("subscribeToRoom", roomId);
  },
  beforeDestroy: function() {
    const roomId = this.$route.query.roomId;
    if (!roomId) {
      this.$store.dispatch("triggerError");
      return;
    }

    this.$store.dispatch("unsubscribeToRoom", roomId);
  },
  methods: {
    showButton() {
      return process.env.VUE_APP_NEED_MORE_INFO;
    },
    modifyUserInformation(userInformation) {
      const data = {
        user: userInformation,
        roomId: this.$route.query.roomId,
      };
      this.$store.dispatch("callTechnicianWithInformation", data);
    },
    visibleCreateIncident() {
      //console.log(process.env.VUE_APP_NEED_MORE_INFO)
      return true;
    },
    createIncident() {
      this.$store.dispatch("callTechnician", this.$route.query.roomId);
    },
  },
};
</script>
